import { Timestamp } from '@firebase/firestore-types';
import { Users } from '@just-in-types';

export const addLeadingZero = (value: number) =>
  value < 10 ? `0${value}` : value;

export const prettyMobile = (mobile: string) => {
  const areaCode = mobile.substring(0, 3);
  const prefix = mobile.substring(3, 6);
  const suffix = mobile.substring(6, 10);

  return `(${areaCode}) ${prefix}-${suffix}`;
};

export const isTimestamp = (value: Date | Timestamp): value is Timestamp =>
  typeof (value as Timestamp).toMillis === 'function';

export const assignNiceName = (columnName: Users.ColumnName) => {
  switch (columnName) {
    case 'coupons':
      return 'Coupons';
    case 'dateofbirth':
      return 'Birth Date';
    case 'email':
      return 'Email';
    case 'language':
      return 'Language';
    case 'mobile':
      return 'Phone Number';
      // return 'Mobile';
    case 'mugshot':
      return 'Picture';
    case 'name':
      return 'Name';
    case 'signature':
      return 'Signature';
    case 'site':
      return 'Location';
    case 'timestamp':
      return 'Timestamp';
    case 'date':
      return 'Date';
    case 'time':
      return 'Time';
    case 'vehicles':
      return 'Vehicles';
    case 'zip':
      return 'Zip';
    default:
      return columnName;
  }
};



// WEBPACK FOOTER //
// ./src/views/CheckIns/helpers.ts